export default "__VITE_PUBLIC_ASSET__d8d0f77e__"